// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'

export const Panel = styled.div<{ decorated?: boolean }>`
  background-color: ${({ color }) => color};
  color: ${colors.white100};

  width: 88px;
  margin-bottom: 0;
  height: auto;
  border-radius: 4px;
  border: 1px solid transparent;
  padding: 8px 0;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  ${({ color }) =>
    !color &&
    css`
      border-color: ${colors.gray900};
      color: ${colors.gray900};
    `}

  ${({ decorated }) =>
    decorated &&
    css`
      text-decoration: underline;
    `};
`
